import appCountry from "../../views/appSettings/country.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("country", {
    url: "country/:id",
    parent: "app",
    views: {
      view: {
        template: appCountry,
      },
    },
    reloadOnSearch: false,
    data: { title: "Country" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/country/country.urls.js